import { render, staticRenderFns } from "./StaffUserList.vue?vue&type=template&id=4789b054"
import script from "./StaffUserList.vue?vue&type=script&lang=js"
export * from "./StaffUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports